import { render, staticRenderFns } from "./PaymentType.vue?vue&type=template&id=a2d2bee0&"
import script from "./PaymentType.vue?vue&type=script&lang=ts&"
export * from "./PaymentType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports